<template>
  <div class="tabbar" :style="this.$isios?'height:109px':''">
    <div class="bbox">
    <router-link to="/message" class="tab-item" tag="div" style="cursor:pointer;">
      <el-badge v-if="pagesize>0" :value="pagesize" :max="99" class="item">
      <img alt="" :src="this.$route.path == '/message' ? msg1 : msg"/>
      </el-badge>
      <img alt="" v-if="pagesize==0" :src="this.$route.path == '/message' ? msg1 : msg"/>
    </router-link>
      <router-link v-if="user.usertype == '02'" to="/studentmain" class="tab-item" tag="div" style="cursor:pointer;">
        <img alt="" :src="this.$route.path == '/studentmain' ?home1 :home"/>
      </router-link>
      <router-link v-if="user.usertype == '01'" to="/teachmain" class="tab-item" tag="div" style="cursor:pointer;">
        <img alt="" :src="this.$route.path == '/teachmain' ?home1 :home"/>
      </router-link>
    <router-link to="/person" class="tab-item" tag="div" style="cursor:pointer;">
      <img alt="" :src="this.$route.path == '/person'? person1 : person"/>
    </router-link>
    </div>
  </div>
</template>


<script>
  export default{
    data(){
      return{
        msg1:require("../../assets/img/msg1.png"),
        msg:require("../../assets/img/msg.png"),
        home:require("../../assets/img/home.png"),
        home1:require("../../assets/img/home1.png"),
        person:require("../../assets/img/person.png"),
        person1:require("../../assets/img/person1.png"),
        pagesize:0,
        user: [],

      }
    },
    created() {
      let that = this
      this.$ajax.get('/getInfo').then(function(res) {
        if (res.code == 200) {
          that.user = res.user;
        }
      });

      this.$ajax.get('/system/notice/listall',this.queryParams).then(function (res) {
        if (res.code == 200) {
          that.pagesize = res.total;
        }
        if(res.code==401)
        {
          this.$toast.fail(res.msg);
          location.href = '/login';
        }
      })
    }
  }
</script>

<style>
  .tabbar{height: 69px;position: fixed;bottom:0px;width: 100%;box-shadow:0px 2px 4px 0px rgba(0,0,0,0.5);background-color: #fff;}
  .bbox{
      display: flex;
      justify-content: space-around;
      height: 50px;
      align-items: center;
  }

  .tab-item img{width: 36px;height: 36px; cursor:pointer;}
  .tabbar .tab-item:nth-child(2) img{width: 40px;height: 40px;}
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Tabbar.vue